var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9975 0.0205078C27.0032 0.0205078 0.0078125 27.0159 0.0078125 60.0102C0.0078125 93.0046 27.0032 120 59.9975 120C92.9919 120 119.987 93.0046 119.987 60.0102C119.987 27.0159 92.9919 0.0205078 59.9975 0.0205078ZM85.1932 49.812L56.3981 78.607C53.9986 81.0066 50.3992 81.0066 47.9996 78.607L34.8018 65.4093C32.4023 63.0097 32.4023 59.4103 34.8018 57.0107C37.2014 54.6111 40.8008 54.6111 43.2004 57.0107L52.1989 66.0092L76.7946 41.4134C79.1942 39.0138 82.7936 39.0138 85.1932 41.4134C87.5928 43.813 87.5928 47.4124 85.1932 49.812Z",
    fill: "#0146ad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.b8c6d2fa.svg";
export { ForwardRef as ReactComponent };